import { createStore } from 'satcheljs';
import type { FeedbackManagerStore } from './schema/FeedbackManagerState';

let locationFeedbackManagerStore: FeedbackManagerStore = {
    feedbackManagerState: undefined,
};

let LocationFeedbackManagerStore = createStore<FeedbackManagerStore>(
    'locationFeedbackManagerStore',
    locationFeedbackManagerStore
)();
export default LocationFeedbackManagerStore;
